"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _primaryPanel = _interopRequireWildcard(require("./primary-panel"));
var _secondaryPanel = _interopRequireDefault(require("./secondary-panel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

/**
 * Local Imports
*/

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c7lbjmu"
});
const TrustpilotMobile = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TrustpilotMobile",
  class: "pl-tr6kbb9"
});

/**
 * HPDualMarquee Component.
 *
 * @param {Object} props React props
 * @param {String} props._name React props
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @param {String} props.marqueeLayout Layout Selection
 * @param {Object} props.primaryPanel Main Message Props
 * @param {Object} props.secondaryPanel Secondary Message Props
 * @returns {React.ReactElement} HPDualMarquee Component
 * @public
 */

function HPDualMarquee({
  _name,
  verticalPadding,
  marqueeLayout = 'primary-secondary',
  primaryPanel,
  secondaryPanel
}) {
  const {
    rating,
    trustpilotUrl,
    trustpilotLogo
  } = primaryPanel;
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: marqueeLayout === 'primary-secondary' ? 'hp-dual-marquee-primary' : 'hp-dual-marquee-secondary',
    verticalMargin: "none",
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(Container, {
    className: marqueeLayout === 'secondary-primary' && 'reversed'
  }, /*#__PURE__*/_react.default.createElement(_primaryPanel.default, {
    primaryPanel: primaryPanel
  }), trustpilotUrl && /*#__PURE__*/_react.default.createElement(TrustpilotMobile, {
    "data-cy": "trustpilot-mobile"
  }, /*#__PURE__*/_react.default.createElement(_primaryPanel.TrustpilotLink, {
    rating: rating,
    trustpilotLogo: trustpilotLogo,
    trustpilotUrl: trustpilotUrl
  })), /*#__PURE__*/_react.default.createElement(_secondaryPanel.default, {
    secondaryPanel: secondaryPanel
  })));
}
var _default = exports.default = HPDualMarquee;
HPDualMarquee.propTypes = {
  marqueeLayout: _propTypes.default.oneOf(['primary-secondary', 'secondary-primary']).isRequired,
  primaryPanel: _propTypes.default.shape({
    ..._primaryPanel.default.propTypes
  }).isRequired,
  secondaryPanel: _propTypes.default.shape({
    ..._secondaryPanel.default.propTypes
  }).isRequired,
  ..._patternLibraryUtils.paddingProps
};